<template>
    <Map mapType="LSA"/>
</template>

<script>
import Map from '../components/Map.vue'

export default {
    name: 'LsaMap',
    components: { Map }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>